var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-tabs',{staticClass:"tab-page",attrs:{"color":"#055C9D","title-active-color":"rgba(0, 0, 0, 0.9)","title-inactive-color":"rgba(0, 0, 0, 0.4)","line-width":"106"},on:{"click":(name) => _vm.checkSampleFinish(name)},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }